const mobileSocialWidget = () => {
  const socialShareWidget = $('#social-media-widget');
  const mobileNav = $('.mobile-nav .overlay-scroller>ul');
  const footer = $('#injected-footer');
  if (window.innerWidth < 1210) {
    if (mobileNav.find('#social-media-widget').length === 0) {
      mobileNav.append(socialShareWidget);
    }
  } else {
    footer.after(socialShareWidget);
  }
};

export { mobileSocialWidget };



// WEBPACK FOOTER //
// ./partial-scripts/mobileSocialWidget.js